module.exports = __webpack_public_path__ + "static/media/georges-madbar-grill.4f0894e7.jpg";